import { IconKey,IconReportAnalytics } from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconReportAnalytics
};
//

const Sales = {

    id: 'sales',
    title: 'Sales',
    type: 'group',
    display_id:'R',
    icon: icons.IconReportAnalytics,
    children: [
        {
            id: 'code_activation',
            title: 'Code Activation',
            type: 'item',
            display_id:52,
            url: '/Department/Sales/code_activation',
            breadcrumbs: false
        },
        {
            id: 'csp_network',
            title: 'CSP Network',
            type: 'item',
            display_id:66,
            url: '/Department/Sales/csp_network',
            breadcrumbs: false
        },
        {
            id: 'mandate',
            title: 'Mandate',
            type: 'item',
            display_id:67,
            url: '/Department/Sales/mandate',
            breadcrumbs: false
        },
        {
            id: 'csp_activity',
            title: 'CSP Activity',
            type: 'item',
            display_id:69,
            url: '/Department/Sales/csp_activity',
            breadcrumbs: false
        },
        {
            id: 'transaction_report',
            title: 'Transaction Report',
            type: 'item',
            display_id:70,
            url: '/Department/Sales/transaction_report',
            breadcrumbs: false
        },
        
    ]
}

export default Sales;